import React from 'react'
import { Button, Form, Input, Modal, Icon } from 'semantic-ui-react'
import {PositiveNumInput} from '../../../componentes/PositiveNumInput/PositiveNumInput'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import Single from '../../../componentes/Single'
import EditarProducto from '../../Productos/Componentes/editarCatalogo'
import EditarProveedor from '../../Productos/Componentes/editarProveedor'
import { formatStrInput } from '../../../formatInput'
import SubmitButton from '../../../componentes/submitButton/submitButton'
import {Table} from 'semantic-ui-react'
import { AuthContext } from '../../../Auth'
import ProveedorImport from '../../../componentes/ProveedorImport/ProveedorImport'
import FormStyles from '../../../componentes/forms/form.module.css'
import CatalogImport from '../../../componentes/CatalogImport/CatalogImport'
import {getCompanyCollection} from '../../../firebase'

const getVisibleData = (data, search) => {
    const term = formatStrInput(search || '')
    if (!term) return data
    return data.filter(item => Object.values(item).some(value =>
        formatStrInput(String(value === undefined || value === null ? '' : value)).includes(term)
    ))
}

class Catalog extends React.Component {
    static contextType = AuthContext
    constructor(props) {
        super(props)
        this.state = {
            catalog: 'presentacion',
            search: '',
        }
    }
    handleClick = (name) => {
        this.setState({ catalog: name })
    }
    render() {
        return (
            <section>
                <div className="secondnav" >
                    <button name='producto' className={`${this.state.catalog === "producto"?"active":null}`} onClick={() => { this.handleClick('producto') }}>Producto</button>
                    <button name='tipo' className={`${this.state.catalog === "tipo"?"active":null}`} onClick={() => { this.handleClick('tipo') }}>Tipo</button>
                    <button name='unidades' className={`${this.state.catalog === "unidades"?"active":null}`} onClick={() => { this.handleClick('unidades') }}>Unidades</button>
                    <button name='marca' className={`${this.state.catalog === "marca"?"active":null}`} onClick={() => { this.handleClick('marca') }}>Marca</button>
                    <button name='proveedor' className={`${this.state.catalog === "proveedor"?"active":null}`} onClick={() => { this.handleClick('proveedor') }}>Proveedor</button>
                    <button name='presentacion' className={`${this.state.catalog === "presentacion"?"active":null}`} onClick={() => { this.handleClick('presentacion') }}>Presentación</button>
                    <Input className='secondnavSearch' icon='search' placeholder='Buscar...' value={this.state.search} onChange={(e, {value}) => this.setState({search: value})} />
                </div>
                <Producto search={this.state.search} hidden={this.state.catalog !== 'producto'} currentUser={this.context.currentUser} />
                <Tipo search={this.state.search} hidden={this.state.catalog !== 'tipo'} currentUser={this.context.currentUser} />
                <Unidades search={this.state.search} hidden={this.state.catalog !== 'unidades'} currentUser={this.context.currentUser} />
                <Marca search={this.state.search} hidden={this.state.catalog !== 'marca'} currentUser={this.context.currentUser} />
                <Proveedor search={this.state.search} hidden={this.state.catalog !== 'proveedor'} currentUser={this.context.currentUser} />
                <Presentacion search={this.state.search} hidden={this.state.catalog !== 'presentacion'} currentUser={this.context.currentUser} />
            </section>
        )
    }
}
class Tipo extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            doc: {
                nombre: ''
            },
            data: [],
            filteredData: [],
            message: '',
            useModal: false,
        }
        this.currentUser = props.currentUser
        this.collection = 'TiposProducto'
        this.database = null
    }
    handleChange = (e, { name, value }) => {
        this.setState({
            doc: {
                [name]: value
            }
        })
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.doc.nombre !== prevState.doc.nombre) {
            this.filter()
        }
    }
    async componentDidMount() {
        this.database = await getCompanyCollection(this.collection)
        this.getData()
    }
    getData = () => {
        this.database.orderBy('nombre', 'asc').onSnapshot(snap => {
            const data = []
            for (let i = 0; i < snap.docs.length; i++) {
                data.push({
                    id: snap.docs[i].id,
                    ...snap.docs[i].data(),
                })
            }
            this.setState({ data, filteredData: data })
        })
    }
    handleBlur = (e) => {
        const name = e.target.name
        const formatedStr = formatStrInput(this.state.doc[name])
        const doc = { ...this.state.doc }
        doc[name] = formatedStr
        this.setState({ doc })
    }
    filter = async () => {
        const inputName = formatStrInput(this.state.doc.nombre)
        const filteredData = []
        for (let i = 0; i < this.state.data.length; i++) {
            const inDataName = formatStrInput(this.state.data[i].nombre)
            if (inDataName.indexOf(inputName) > -1) {
                filteredData.push(this.state.data[i])
            }
        }
        this.setState({ filteredData })
    }
    validateSubmit = async () => {
        if (this.state.doc.nombre === '') {
            this.setState({ message: 'Llene todos los campos' })
            return null
        }
        const snap = await this.database
            .where('nombre', '==', formatStrInput(this.state.doc.nombre))
            .get()
        if (snap.size > 0) {
            this.setState({ message: 'Elemento repetido' })
            return false
        }
        return true
    }
    handleSubmit = async () => {
        try {
            if (!await this.validateSubmit()) return null
            let doc = { ...this.state.doc }
            doc.nombre = formatStrInput(doc.nombre)
            await this.database.add(doc)
            this.setState({
                message: 'Tipo agregado con éxito',
                doc: {
                    nombre: ''
                },
            })
            this.changeUsModal(false)
        }
        catch (error) {
            this.setState({
                message: 'Ocurrió un error'
            })
            console.log(error)
        }
    }
    admin =(element)=>{
		if (this.currentUser.rol === "admin" || this.currentUser.rol === "warehouseAdmin"){
			return(
                <button className='borrar' onClick={
                    () =>{
                        const confirmBox = window.confirm(`Esta accion no se puede revertir!!! Desea borrar ${element.nombre} ?`)
                        if (confirmBox === true) {this.borrar(element.id)}
                    }
                    }><Icon name='trash alternate' />
                </button>
			)
		}
	}
    borrar= async (id) => {
		this.database.doc(id).delete().then(() => {
            console.log("Borrado");
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
	}
    modalAgregar = () => (
		<Modal
			className={FormStyles.modal}
			onClose={() => this.changeUsModal(false)}
			onOpen={() => this.changeUsModal(true)}
			open={this.state.useModal}
			trigger={<button><Icon name='plus' />Nuevo</button>}>
			<Modal.Header>Agregar nuevo tipo de producto</Modal.Header>
			<Modal.Content>
                <Form autoComplete='off'>
                    <Form.Field>
                        <Input required placeholder='Tipo' onChange={this.handleChange} onBlur={this.handleBlur} name='nombre' value={this.state.doc.nombre} autoComplete="off" />
                    </Form.Field>
                    <Form.Field>
                        <SubmitButton handleSubmit={this.handleSubmit}>Enviar</SubmitButton>
                    </Form.Field>
                </Form>
                <p>{this.state.message}</p>
			</Modal.Content>
		</Modal>
	)
	changeUsModal=(open)=>{
		this.setState({useModal:open})
	}
    render() {
        return (
            <section hidden={this.props.hidden}>
                <div className='filtros'>
                    <h3>Tipo de Producto</h3>
                    <this.modalAgregar />
                </div>
                <div>
                {
                    getVisibleData(this.state.filteredData, this.props.search).map((element, i) =>
                        <div className='divrow' key={i} >
                            <div className='contentLeft'>
                                {element.nombre}
                            </div>
                            <div className='borrar'>
                                {this.admin(element)} 
                            </div>
                        </div>
                    )
                }
                </div>
            </section>
        )
    }
}
class Unidades extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            doc: {
                nombre: ''
            },
            data: [],
            filteredData: [],
            message: '',
            useModal: false,
        }
        this.collection = 'Unidades'
        this.currentUser = props.currentUser
        this.database = null
    }
    handleChange = (e, { name, value }) => {
        this.setState({
            doc: {
                [name]: value
            }
        })
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.doc.nombre !== prevState.doc.nombre) {
            this.filter()
        }
    }
    async componentDidMount() {
        this.database = await getCompanyCollection(this.collection)
        this.getData()
    }
    getData = () => {
        this.database.orderBy('nombre', 'asc').onSnapshot(snap => {
            const data = []
            for (let i = 0; i < snap.docs.length; i++) {
                data.push({
                    id: snap.docs[i].id,
                    ...snap.docs[i].data(),
                })
            }
            this.setState({ data, filteredData: data })
        })
    }
    handleBlur = (e) => {
        const name = e.target.name
        const formatedStr = formatStrInput(this.state.doc[name])
        const doc = { ...this.state.doc }
        doc[name] = formatedStr
        this.setState({ doc })
    }
    filter = async () => {
        const inputName = formatStrInput(this.state.doc.nombre)
        const filteredData = []
        for (let i = 0; i < this.state.data.length; i++) {
            const inDataName = formatStrInput(this.state.data[i].nombre)
            if (inDataName.indexOf(inputName) > -1) {
                filteredData.push(this.state.data[i])
            }
        }
        this.setState({ filteredData })
    }
    validateSubmit = async () => {
        if (this.state.doc.nombre === '') {
            this.setState({ message: 'Llene todos los campos' })
            return null
        }
        const snap = await this.database
            .where('nombre', '==', formatStrInput(this.state.doc.nombre))
            .get()
        if (snap.size > 0) {
            this.setState({ message: 'Elemento repetido' })
            return false
        }
        return true
    }
    handleSubmit = async () => {
        try {
            if (!await this.validateSubmit()) return null
            let doc = { ...this.state.doc }
            doc.nombre = formatStrInput(doc.nombre)
            await this.database.add(doc)
            this.setState({
                message: 'Tipo agregado con éxito',
                doc: {
                    nombre: ''
                },
            })
            this.changeUsModal(false)
        }
        catch (error) {
            this.setState({
                message: 'Ocurrió un error'
            })
            console.log(error)
        }
    }
    borrar= async (id) => {
		this.database.doc(id).delete().then(() => {
            console.log("Borrado");
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
	}
    admin =(element)=>{
		if (this.currentUser.rol === "admin" || this.currentUser.rol === "warehouseAdmin"){
			return(
                <button className='borrar' onClick={
                    () =>{
                        const confirmBox = window.confirm(`Esta accion no se puede revertir!!! Desea borrar ${element.nombre} ?`)
                        if (confirmBox === true) {this.borrar(element.id)}
                    }
                    }><Icon name='trash alternate' />
                </button>
			)
		}
	}
    modalAgregar = () => (
		<Modal 
			className={FormStyles.modal}
			onClose={() => this.changeUsModal(false)}
			onOpen={() => this.changeUsModal(true)}
			open={this.state.useModal}
			trigger={<button><Icon name='plus' />Nuevo</button>}>
			<Modal.Header>Agregar nueva unidad</Modal.Header>
			<Modal.Content>
            <Form autoComplete='off'>
                <Form.Field>
                    <Input required placeholder='Unidades' onChange={this.handleChange} onBlur={this.handleBlur} name='nombre' value={this.state.doc.nombre} />
                </Form.Field>
                <Form.Field>
                    <SubmitButton handleSubmit={this.handleSubmit}>Agregar</SubmitButton>
                </Form.Field>
            </Form>
                <p>{this.state.message}</p>
			</Modal.Content>
		</Modal>
	)
	changeUsModal=(open)=>{
		this.setState({useModal:open})
	}
    render() {
        return (
            <section hidden={this.props.hidden}>
                <div className='filtros'>
                    <h3>Unidades</h3>
                    <this.modalAgregar />
                </div>
                <p>{this.state.message}</p>
                <div>
                    {
                        getVisibleData(this.state.filteredData, this.props.search).map((element, i) =>
                        <div className='divrow' key={i} >
                            <div className='contentLeft'>
                                {element.nombre}
                            </div>
                            <div className='borrar'>
                                {this.admin(element)} 
                            </div>
                        </div>
                        )
                    }
                </div>
            </section>
        )
    }
}
class Marca extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            doc: {
                nombre: ''
            },
            data: [],
            filteredData: [],
            message: '',
            useModal: false,
        }
        this.currentUser = props.currentUser
        this.collection = 'Marcas'
        this.database = null
    }
    handleChange = (e, { name, value }) => {
        this.setState({
            doc: {
                [name]: value
            }
        })
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.doc.nombre !== prevState.doc.nombre) {
            this.filter()
        }
    }
    async componentDidMount() {
        this.database = await getCompanyCollection(this.collection)
        this.getData()
    }
    getData = () => {
        this.database.orderBy('nombre', 'asc').onSnapshot(snap => {
            const data = []
            for (let i = 0; i < snap.docs.length; i++) {
                data.push({
                    id: snap.docs[i].id,
                    ...snap.docs[i].data(),
                })
            }
            this.setState({ data, filteredData: data })
        })
    }
    handleBlur = (e) => {
        const name = e.target.name
        const formatedStr = formatStrInput(this.state.doc[name])
        const doc = { ...this.state.doc }
        doc[name] = formatedStr
        this.setState({ doc })
    }
    filter = async () => {
        const inputName = formatStrInput(this.state.doc.nombre)
        const filteredData = []
        for (let i = 0; i < this.state.data.length; i++) {
            const inDataName = formatStrInput(this.state.data[i].nombre)
            if (inDataName.indexOf(inputName) > -1) {
                filteredData.push(this.state.data[i])
            }
        }
        this.setState({ filteredData })
    }
    validateSubmit = async () => {
        if (this.state.doc.nombre === '') {
            this.setState({ message: 'Llene todos los campos' })
            return null
        }
        const snap = await this.database
            .where('nombre', '==', formatStrInput(this.state.doc.nombre))
            .get()
        if (snap.size > 0) {
            this.setState({ message: 'Elemento repetido' })
            return false
        }
        return true
    }
    handleSubmit = async () => {
        try {
            if (!await this.validateSubmit()) return null
            let doc = { ...this.state.doc }
            doc.nombre = formatStrInput(doc.nombre)
            doc.tipo = "productos"
            await this.database.add(doc)
            this.setState({
                message: 'Tipo agregado con éxito',
                doc: {
                    nombre: ''
                },
            })
        }
        catch (error) {
            this.setState({
                message: 'Ocurrió un error'
            })
            console.log(error)
        }
        this.changeUsModal(false)
    }
    admin =(element)=>{
		if (this.currentUser.rol === "admin" || this.currentUser.rol === "warehouseAdmin"){
			return(
                <button className='borrar' onClick={
                    () =>{
                        const confirmBox = window.confirm(`Esta accion no se puede revertir!!! Desea borrar ${element.nombre} ?`)
                        if (confirmBox === true) {this.borrar(element.id)}
                    }
                    }><Icon name='trash alternate' />
                </button>
			)
		}
	}
    borrar= async (id) => {
		this.database.doc(id).delete().then(() => {
            console.log("Borrado");
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
	}
    modalAgregar = () => (
		<Modal 
			className={FormStyles.modal}
			onClose={() => this.changeUsModal(false)}
			onOpen={() => this.changeUsModal(true)}
			open={this.state.useModal}
			trigger={<button><Icon name='plus' />Nuevo</button>}>
			<Modal.Header>Agregar nueva marca</Modal.Header>
			<Modal.Content>
            <Form autoComplete='off'>
                <Form.Field>
                    <Input required placeholder='Marca' onChange={this.handleChange} onBlur={this.handleBlur} name='nombre' value={this.state.doc.nombre} />
                </Form.Field>
                <div className={FormStyles.actions}>
                    <CatalogImport
                        label='Marcas'
                        template='plantilla-marcas.xlsx'
                        headers={['Nombre']}
                        items={this.state.data}
                        getKey={item => item.nombre}
                        mapRow={row => {
                            const nombre = formatStrInput(row[0])
                            if(!nombre) throw new Error('Nombre requerido')
                            return {nombre, tipo: 'productos'}
                        }}
                        addItem={item => this.database.add(item)}
                    />
                    <Button type='button' basic onClick={() => this.changeUsModal(false)}>Cancelar</Button>
                    <SubmitButton handleSubmit={this.handleSubmit}>Agregar</SubmitButton>
                </div>
            </Form>
                <p>{this.state.message}</p>
			</Modal.Content>
		</Modal>
	)
	changeUsModal=(open)=>{
		this.setState({useModal:open})
	}
    render() {
        return (
            <section hidden={this.props.hidden}>
                <div className='filtros'>
                    <h3>Marca</h3>
                    <this.modalAgregar />
                </div>
                <p>{this.state.message}</p>
                <div>
                    {
                        getVisibleData(this.state.filteredData, this.props.search).map((element, i) =>
                        <div className='divrow' key={i} >
                            <div className='contentLeft'>
                                {element.nombre}
                            </div>
                            <div className='borrar'>
                                {this.admin(element)} 
                            </div>
                        </div>
                        )
                    }
                </div>
            </section>
        )
    }
}
class Proveedor extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            nombre: '',
            telefono: '',
            correo: '',
            direccion: '',
            data: [],
            filteredData: [],
            message: '',
            useModal: false,
        }
        this.currentUser = props.currentUser
        this.collection = 'Proveedores'
        this.database = null
    }
    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    async componentDidMount() {
        this.database = await getCompanyCollection(this.collection)
        this.getData()
    }
    getData = () => {
        this.database.orderBy('nombre', 'asc').onSnapshot(snap => {
            const data = []
            for (let i = 0; i < snap.docs.length; i++) {
                data.push({
                    id: snap.docs[i].id,
                    ...snap.docs[i].data(),
                })
            }
            this.setState({ data, filteredData: data })
        })
    }
    filter = async () => {
        const inputName = formatStrInput(this.state.nombre)
        const filteredData = []
        for (let i = 0; i < this.state.data.length; i++) {
            const inDataName = formatStrInput(this.state.data[i].nombre)
            if (inDataName.indexOf(inputName) > -1) {
                filteredData.push(this.state.data[i])
            }
        }
        this.setState({ filteredData })
    }
    validateSubmit = async () => {
        if (this.state.nombre === '') {
            this.setState({ message: 'Llene todos los campos' })
            return null
        } else {
            this.setState({nombre:this.state.nombre.toUpperCase()})
        }
        const snap = await this.database
            .where('nombre', '==', this.state.nombre)
            .get()
        if (snap.size > 0) {
            this.setState({ message: 'Elemento repetido' })
            return false
        }
        return true
    }
    handleSubmit = async () => {
        try {
            if (!await this.validateSubmit()) return null
            await this.database.add(
                {nombre: this.state.nombre,
                telefono: this.state.telefono,
                correo: this.state.correo,
                direccion: this.state.direccion,
                tipo: "productos"
            }
            )
            this.setState({
                message: 'Tipo agregado con éxito',
                nombre: '',
                telefono: '',
                correo: '',
                direccion: '',
            })
            this.changeUsModal(false)
        }
        catch (error) {
            this.setState({
                message: 'Ocurrió un error'
            })
            console.log(error)
        }
        this.changeUsModal(false)
    }
    addProveedor = proveedor => this.database.add({
        ...proveedor,
        tipo: 'productos',
    })
    admin =(row)=>{
		if (this.currentUser.rol === "admin" || this.currentUser.rol === "warehouseAdmin"){
			return(
            <EditarProveedor
                data={row}
                tabla={this.collection}
            />
			)
		}
	}
    modalAgregar = () => (
		<Modal
			className={FormStyles.modal}
			onClose={() => this.changeUsModal(false)}
			onOpen={() => this.changeUsModal(true)}
			open={this.state.useModal}
			trigger={<button><Icon name='plus' />Nuevo</button>}>
			<Modal.Header>Agregar nuevo proveedor</Modal.Header>
			<Modal.Content>
            <Form className={FormStyles.form} autoComplete='off'>
                <Form.Field className={FormStyles.fieldRow} required>
                    <label className={FormStyles.fieldLabel}>Nombre</label>
                    <div className={FormStyles.fieldContent}>
                        <Input fluid required placeholder='Nombre del proveedor' onChange={this.handleChange} name='nombre' value={this.state.nombre} />
                    </div>
                </Form.Field>
                <Form.Field className={FormStyles.fieldRow}>
                    <label className={FormStyles.fieldLabel}>Teléfono</label>
                    <div className={FormStyles.fieldContent}>
                        <Input fluid type='tel' placeholder='Número telefónico' onChange={this.handleChange} name='telefono' value={this.state.telefono} />
                    </div>
                </Form.Field>
                <Form.Field className={FormStyles.fieldRow}>
                    <label className={FormStyles.fieldLabel}>Correo</label>
                    <div className={FormStyles.fieldContent}>
                        <Input fluid type='email' placeholder='correo@proveedor.com' onChange={this.handleChange} name='correo' value={this.state.correo} />
                    </div>
                </Form.Field>
                <Form.Field className={FormStyles.fieldRow}>
                    <label className={FormStyles.fieldLabel}>Dirección</label>
                    <div className={FormStyles.fieldContent}>
                        <Input fluid placeholder='Dirección del proveedor' onChange={this.handleChange} name='direccion' value={this.state.direccion} />
                    </div>
                </Form.Field>
                <div className={FormStyles.actions}>
                    <ProveedorImport proveedores={this.state.data} addProveedor={this.addProveedor} />
                    <Button type='button' basic onClick={() => this.changeUsModal(false)}>Cancelar</Button>
                    <SubmitButton handleSubmit={this.handleSubmit}>Agregar</SubmitButton>
                </div>
            </Form>
                <p>{this.state.message}</p>
			</Modal.Content>
		</Modal>
	)
	changeUsModal=(open)=>{
		this.setState({useModal:open})
	}
    render() {
        return (
            <section hidden={this.props.hidden}>
                <div className='filtros'>
                    <h3>Proveedor</h3>
                    <this.modalAgregar />
                </div>
                <p>{this.state.message}</p>
                <div  className="body tabla">
                    <table><tbody>
                        <tr>
                            <th>Proveedor</th>
                            <th>Telefono</th>
                            <th>Correo</th>
                            <th>Direccion</th>
                        </tr>
                        {getVisibleData(this.state.filteredData, this.props.search).map((row, i)=>{
                            return(
                                <Table.Row key={i}>
                                    <Table.Cell>{row.nombre}</Table.Cell>
                                    <Table.Cell>{row.telefono}</Table.Cell>
                                    <Table.Cell>{row.correo}</Table.Cell>
                                    <Table.Cell>{row.direccion}</Table.Cell>
                                    <Table.Cell>{this.admin(row)}</Table.Cell>
                                </Table.Row>
                            )
                        })}
                    </tbody></table>
                </div>
            </section>
        )
    }
}
class Presentacion extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            doc: {
                clave: '',
                producto: '',
                contenido: 0,
                unidades: '',
                nombre: '',
            },
            data: [],
            filteredData: [],
            message: '',
            useModal: false,
        }
        this.currentUser = props.currentUser
        this.collection = 'Presentacion'
        this.database = null
    }
    async componentDidMount() {
        this.database = await getCompanyCollection(this.collection)
        this.getData()
    }
    getData = () => {
        this.database.orderBy('clave', 'asc').onSnapshot(snap => {
            const data = []
            for (let i = 0; i < snap.docs.length; i++) {
                data.push({
                    id: snap.docs[i].id,
                    ...snap.docs[i].data(),
                })
            }
            this.setState({ data, filteredData: data })
        })
    }
    handleChange = async (e, { name, value }) => {
        const presentacion = { ...this.state.doc }
        if (name === 'producto') {
            presentacion.clave = `${value} / ${this.state.doc.nombre}`
            const productos = await getCompanyCollection('Productos')
            const producto = (await productos.where('nombre', '==', value).get()).docs[0]
            presentacion.unidades = producto.data().unidades
        }
        else if (name === 'nombre')
            presentacion.clave = formatStrInput(`${this.state.doc.producto} / ${value}`)
        presentacion[name] = value
        this.setState({
            doc: presentacion
        })
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.doc.clave !== prevState.doc.clave) {
            this.filter()
        }
    }
    handleBlur = (e) => {
        const name = e.target.name
        const formatedStr = formatStrInput(this.state.doc[name])
        const doc = { ...this.state.doc }
        doc[name] = formatedStr
        this.setState({ doc })
    }
    filter = async () => {
        const inputName = formatStrInput(this.state.doc.clave)
        const filteredData = []
        for (let i = 0; i < this.state.data.length; i++) {
            const inDataName = formatStrInput(this.state.data[i].clave)
            if (inDataName.indexOf(inputName) > -1) {
                filteredData.push(this.state.data[i])
            }
        }
        this.setState({ filteredData })
    }
    validateSubmit = async () => {
        const doc = this.state.doc
        if (doc.nombre === '' || doc.contenido === 0 || doc.producto === '') {
            this.state.message = 'Llene todos los campos'
            return false
        }
        const snap = await this.database
            .where('clave', '==', formatStrInput(this.state.doc.clave))
            .get()
        if (snap.size > 0) {
            this.setState({ message: 'Elemento Repetido' })
            return false
        }
        return true
    }
    handleSubmit = async (e) => {
        e.preventDefault()
        try {
            if (!await this.validateSubmit()) return null
            let doc = { ...this.state.doc }
            doc.nombre = formatStrInput(doc.nombre)
            await this.database.add(doc)
            this.setState({
                message: 'Presentación agregada con éxito',
                doc: {
                    clave: '',
                    producto: '',
                    contenido: 0,
                    unidades: '',
                    nombre: '',
                },
            })
        }
        catch (error) {
            this.setState({
                message: 'Ocurrió un error'
            })
            console.log(error)
        }
        this.changeUsModal(false)
    }
    admin =(element)=>{
		if (this.currentUser.rol === "admin" || this.currentUser.rol === "warehouseAdmin"){
			return(
                <button className='borrar' onClick={
                    () =>{
                        const confirmBox = window.confirm(`Esta accion no se puede revertir!!! Desea borrar ${element.nombre} ?`)
                        if (confirmBox === true) {this.borrar(element.id)}
                    }
                    }><Icon name='trash alternate' />
                </button>
			)
		}
	}
    borrar= async (id) => {
		this.database.doc(id).delete().then(() => {
            console.log("Borrado");
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
	}
    modalAgregar = () => (
		<Modal 
			className={FormStyles.modal}
			onClose={() => this.changeUsModal(false)}
			onOpen={() => this.changeUsModal(true)}
			open={this.state.useModal}
			trigger={<button><Icon name='plus' />Nuevo</button>}>
			<Modal.Header>Agregar Nueva Presentación</Modal.Header>
			<Modal.Content>
            <Form autoComplete='off'>
                <Form.Field>
                    <Input placeholder='Clave' name='clave' value={this.state.doc.clave} disabled />
                </Form.Field>
                <Form.Field>
                    Producto:
                    <Single
                        placeholder='Producto'
                        onChange={this.handleChange}
                        name='producto'
                        columna='nombre'
                        tabla='Productos'
                        value={this.state.doc.producto}
                    />
                </Form.Field>
                <Form.Field>
                    Descripcion:
                    <Input required placeholder='Nombre' onChange={this.handleChange} onBlur={this.handleBlur} name='nombre' value={this.state.doc.nombre} />
                </Form.Field>
                <Form.Field>
                    <span>Contiene:</span>
                    <PositiveNumInput required placeholder='Contenido' onChange={this.handleChange} name='contenido' value={this.state.doc.contenido} />
                    <span>{this.state.doc.unidades}</span>
                </Form.Field>
                <div className={FormStyles.actions}>
                    <CatalogImport
                        label='Presentaciones'
                        template='plantilla-presentaciones.xlsx'
                        headers={['Producto', 'Descripción', 'Contenido', 'Unidades']}
                        items={this.state.data}
                        getKey={item => item.clave}
                        mapRow={row => {
                            const producto = formatStrInput(row[0])
                            const nombre = formatStrInput(row[1])
                            const contenido = Number(row[2])
                            const unidades = formatStrInput(row[3])
                            if(!producto || !nombre || !unidades || !Number.isFinite(contenido) || contenido <= 0) throw new Error('Datos inválidos')
                            return {producto, nombre, contenido, unidades, clave: formatStrInput(`${producto} / ${nombre}`)}
                        }}
                        addItem={item => this.database.add(item)}
                    />
                    <Button type='button' basic onClick={() => this.changeUsModal(false)}>Cancelar</Button>
                    <SubmitButton handleSubmit={this.handleSubmit}>Agregar</SubmitButton>
                </div>
            </Form>
                <p>{this.state.message}</p>
			</Modal.Content>
		</Modal>
	)
	changeUsModal=(open)=>{
		this.setState({useModal:open})
	}
    render() {
        return (
            <section hidden={this.props.hidden}>
                <div className='filtros'>
                    <h3>Presentación</h3>
                    <this.modalAgregar />
                </div>
                <div>
                {
                    getVisibleData(this.state.filteredData, this.props.search).map((element, i) =>
                    <div className='divrow' key={i} >
                        <div className='contentLeft'>
                            {element.clave}
                        </div>
                        <div className='borrar'>
                            {this.admin(element)} 
                        </div>
                    </div>
                    )
                }
                </div>
            </section>
        )
    }
}
class Producto extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            doc: {
                clave: '',
                marca: '',
                tipo: '',
                unidades: '',
                nombre: '',
                formula: ''
            },
            update: {
                clave: '',
                marca: '',
                tipo: '',
                unidades: '',
                nombre: '',
                formula: ''
            },
            data: [],
            filteredData: [],
            message: '',
            useModal: false,
        }
        this.currentUser = props.currentUser
        
        this.collection = 'Productos'
        this.database = null
    }
    async componentDidMount() {
        this.database = await getCompanyCollection(this.collection)
        this.getData()
    }
    getData = () => {
        this.database.orderBy('clave', 'asc').onSnapshot(snap => {
            const data = []
            for (let i = 0; i < snap.docs.length; i++) {
                data.push({
                    id: snap.docs[i].id,
                    ...snap.docs[i].data(),
                })
            }
            this.setState({ data, filteredData: data })
        })
    }
    handleChange = async (e, { name, value }) => {
        const doc = { ...this.state.doc }
        doc[name] = formatStrInput(value)
        const clave = `${doc.nombre} @ ${doc.marca}`
        doc.clave = clave
        this.setState({ doc })
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.doc.clave !== prevState.doc.clave) {
            this.filter()
        }
    }
    handleBlur = (e) => {
        const name = e.target.name
        const formatedStr = formatStrInput(this.state.doc[name])
        const doc = { ...this.state.doc }
        doc[name] = formatedStr
        this.setState({ doc })
    }
    filter = async () => {
        const inputName = formatStrInput(this.state.doc.clave)
        const filteredData = []
        for (let i = 0; i < this.state.data.length; i++) {
            const inDataName = formatStrInput(this.state.data[i].clave)
            if (inDataName.indexOf(inputName) > -1) {
                filteredData.push(this.state.data[i])
            }
        }
        this.setState({ filteredData })
    }
    validateSubmit = async (data) => {
        const doc = data
        if (doc.marca === '' || doc.nombre === '' || doc.tipo === '' || doc.unidades === '') {
            this.setState({ message: 'Llene todos los campos' })
            return false
        }
        const snap = await firebase
            .firestore()
            .collection(this.collection)
            .where('clave', '==', formatStrInput(data.clave))
            .get()
        if (snap.size > 0) {
            this.setState({ message: 'Elemento Repetido' })
            return false
        }
        return true
    }
    handleSubmit = async () => {
        try {
            const validation = await this.validateSubmit(this.state.doc)
            if (!validation) {
                return null
            }
            let doc = { ...this.state.doc }
            doc.nombre = formatStrInput(doc.nombre)
            await firebase.firestore().collection(this.collection).add(doc)
            this.setState({
                message: 'Producto agregado con éxito',
                doc: {
                    clave: '',
                    producto: '',
                    contenido: 0,
                    unidades: '',
                    nombre: '',
                    formula: ''
                },
            })
        }
        catch (error) {
            this.setState({
                message: 'Ocurrió un error'
            })
            console.log(error)
        }
        this.changeUsModal(false)
    }
    admin =(row)=>{
		if (this.currentUser.rol === "admin" || this.currentUser.rol === "warehouseAdmin"){
			return(
            <EditarProducto
                data={row}
                tabla={this.collection}
            />
			)
		}
	}
    modalAgregar = () => (
        <Modal
			className={FormStyles.modal}
			onClose={() => this.changeUsModal(false)}
			onOpen={() => this.changeUsModal(true)}
			open={this.state.useModal}
			trigger={<button><Icon name='plus' />Nuevo</button>}>
			<Modal.Header>Agregar nuevo producto</Modal.Header>
			<Modal.Content>
                <Form autoComplete='off'>
                    <Form.Field>
                        <Input placeholder="Producto" 
                            onChange={this.handleChange} 
                            onBlur={this.handleBlur} name='nombre' 
                            value={this.state.doc.nombre} 
                        />
                    </Form.Field>
                    <Form.Field>
                        <Single
                            placeholder="Marca"
                            onChange={this.handleChange}
                            name='marca'
                            columna='nombre'
                            tabla='Marcas'
                            value={this.state.doc.marca}
                        />
                    </Form.Field>
                    <Form.Field>
                        <Single
                            placeholder="Tipo"
                            onChange={this.handleChange}
                            name='tipo'
                            columna='nombre'
                            tabla='TiposProducto'
                            value={this.state.doc.tipo}
                        />
                    </Form.Field>
                    <Form.Field>
                        <Single
                            placeholder="Unidades"
                            onChange={this.handleChange}
                            name='unidades'
                            columna='nombre'
                            tabla='Unidades'
                            value={this.state.doc.unidades}
                        />
                    </Form.Field>
                    <Form.Field>
                        <Input placeholder="Formula" 
                            onChange={this.handleChange} 
                            onBlur={this.handleBlur} name='formula' 
                            value={this.state.doc.formula} 
                        />
                    </Form.Field>
                    <div className={FormStyles.actions}>
                        <CatalogImport
                            label='Productos'
                            template='plantilla-productos.xlsx'
                            headers={['Nombre', 'Marca', 'Tipo', 'Unidades', 'Fórmula']}
                            items={this.state.data}
                            getKey={item => item.clave}
                            mapRow={row => {
                                const nombre = formatStrInput(row[0])
                                const marca = formatStrInput(row[1])
                                const tipo = formatStrInput(row[2])
                                const unidades = formatStrInput(row[3])
                                const formula = formatStrInput(row[4])
                                if(!nombre || !marca || !tipo || !unidades) throw new Error('Datos inválidos')
                                return {nombre, marca, tipo, unidades, formula, clave: `${nombre} @ ${marca}`}
                            }}
                            addItem={item => this.database.add(item)}
                        />
                        <Button type='button' basic onClick={() => this.changeUsModal(false)}>Cancelar</Button>
                        <SubmitButton handleSubmit={this.handleSubmit}>Agregar</SubmitButton>
                    </div>
                </Form>
                <p>{this.state.message}</p>
			</Modal.Content>
		</Modal>
	)
	changeUsModal=(open)=>{
		this.setState({useModal:open})
	}
    render() {
        return (
            <section hidden={this.props.hidden}>
                <div className='filtros'>
                    <h3>Agregar Producto</h3>
                    <this.modalAgregar />
                </div>
                <p>{this.state.message}</p>
                <div  className="body tabla">
				    <table><tbody>
                        <tr>
                            <th>Nombre</th>
                            <th>Formula</th>
                        </tr>
                        {getVisibleData(this.state.filteredData, this.props.search).map((row, i)=>{
                            return(
                                <Table.Row key={i}>
                                    <Table.Cell>{row.nombre}</Table.Cell>
                                    <Table.Cell>{row.formula}</Table.Cell>
                                    <Table.Cell>{this.admin(row)}</Table.Cell>
                                </Table.Row>
                            )
                        })}
                    </tbody></table>
			    </div>
            </section>
        )
    }
}

export default Catalog
